import React, { useState, useEffect } from "react";
import { getCasos } from "./api/actions";
import Menu from "./componentes-generales/Menu";
import { Outlet, useLocation, useRoutes } from "react-router-dom";
import Footer from "./componentes-generales/Footer";
import MobileMenu from "./componentes-generales/MobileMenu";
/* import { TwitterTimelineEmbed } from "react-twitter-embed"; */

export default function App() {
  const [listaCasos, setListaCasos] = useState([]);
  const [titulo, setTitulo] = useState("");
  const [subtitulo, setSubtitulo] = useState("");
  const [featuredImage, setFeaturedImage] = useState("");
  const [openMenu, setOpenMenu] = useState(false);

  useEffect(() => {
    getCasosConenido();
  }, []);

  const router = useLocation();
  console.log(router.pathname === "/");

  async function getCasosConenido() {
    var responseValues = [];
    let titulo;
    let subtitulo;
    let featuredImage;
    await getCasos().then((res) => {
      for (var i = 0; res.length > i; i++) {
        responseValues.push(JSON.parse(res[i].blocksJSON));
        titulo = res[i].caso_titulo_subtitulo.titulo;
        subtitulo = res[i].caso_titulo_subtitulo.subtitulo;
        featuredImage =
          res[i].featuredImage != null
            ? res[i].featuredImage.node.sourceUrl
            : "";
      }
    });
    setListaCasos([...responseValues]);
    setTitulo(titulo);
    setSubtitulo(subtitulo);
    setFeaturedImage(featuredImage);
  }

  const openCloseMenu = () => {
    setOpenMenu(!openMenu);
  };

  return (
    <div className={`container${router.pathname === "/" ? " home-page" : ""}`}>
      <Menu openCloseMenu={() => openCloseMenu()} />
      {openMenu ? (
        <MobileMenu
          openMenuState={openMenu}
          openCloseMenu={() => openCloseMenu()}
        />
      ) : null}
      <main>
        <Outlet />
        <div className="social-icons">
          <div className="icons flex-column">
            <a
              target="_blank"
              href="mailto:contacto@accionconstitucional.org"
              rel="noreferrer"
            >
              <svg
                width="25"
                height="19"
                viewBox="0 0 25 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24.5264 6.27396C24.7168 6.12057 25 6.26406 25 6.50651V16.625C25 17.9362 23.9502 19 22.6562 19H2.34375C1.0498 19 0 17.9362 0 16.625V6.51146C0 6.26406 0.27832 6.12552 0.473633 6.27891C1.56738 7.13984 3.01758 8.23333 7.99805 11.8997C9.02832 12.6617 10.7666 14.2648 12.5 14.2549C14.2432 14.2698 16.0156 12.632 17.0068 11.8997C21.9873 8.23333 23.4326 7.1349 24.5264 6.27396ZM12.5 12.6667C13.6328 12.6865 15.2637 11.2219 16.084 10.6182C22.5635 5.85339 23.0566 5.43776 24.5508 4.25026C24.834 4.0276 25 3.68125 25 3.3151V2.375C25 1.0638 23.9502 0 22.6562 0H2.34375C1.0498 0 0 1.0638 0 2.375V3.3151C0 3.68125 0.166016 4.02266 0.449219 4.25026C1.94336 5.43281 2.43652 5.85339 8.91602 10.6182C9.73633 11.2219 11.3672 12.6865 12.5 12.6667Z"
                  fill="#20222C"
                />
              </svg>
            </a>
            <a
              target="_blank"
              href="https://www.instagram.com/accionconstitucional/"
              rel="noreferrer"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.0025 5.35948C7.88098 5.35948 5.36319 7.87783 5.36319 11C5.36319 14.1222 7.88098 16.6405 11.0025 16.6405C14.1239 16.6405 16.6417 14.1222 16.6417 11C16.6417 7.87783 14.1239 5.35948 11.0025 5.35948ZM11.0025 14.6671C8.98528 14.6671 7.3362 13.0225 7.3362 11C7.3362 8.97746 8.98037 7.33292 11.0025 7.33292C13.0245 7.33292 14.6687 8.97746 14.6687 11C14.6687 13.0225 13.0196 14.6671 11.0025 14.6671V14.6671ZM18.1877 5.12875C18.1877 5.8602 17.5988 6.44438 16.8724 6.44438C16.1411 6.44438 15.5571 5.85529 15.5571 5.12875C15.5571 4.40221 16.146 3.81312 16.8724 3.81312C17.5988 3.81312 18.1877 4.40221 18.1877 5.12875ZM21.9227 6.46402C21.8393 4.70166 21.4368 3.14058 20.146 1.8544C18.8601 0.568225 17.2994 0.165681 15.5374 0.0773179C13.7215 -0.0257726 8.27853 -0.0257726 6.46258 0.0773179C4.70552 0.160772 3.14479 0.563316 1.85399 1.84949C0.56319 3.13567 0.165644 4.69675 0.0773006 6.45911C-0.0257669 8.27547 -0.0257669 13.7196 0.0773006 15.536C0.160736 17.2983 0.56319 18.8594 1.85399 20.1456C3.14479 21.4318 4.70061 21.8343 6.46258 21.9227C8.27853 22.0258 13.7215 22.0258 15.5374 21.9227C17.2994 21.8392 18.8601 21.4367 20.146 20.1456C21.4319 18.8594 21.8344 17.2983 21.9227 15.536C22.0258 13.7196 22.0258 8.28037 21.9227 6.46402V6.46402ZM19.5767 17.4849C19.1939 18.4471 18.4528 19.1883 17.4859 19.5761C16.038 20.1505 12.6025 20.018 11.0025 20.018C9.40245 20.018 5.96196 20.1456 4.51902 19.5761C3.55705 19.1932 2.81595 18.452 2.42822 17.4849C1.85399 16.0367 1.9865 12.6004 1.9865 11C1.9865 9.39964 1.8589 5.95838 2.42822 4.51512C2.81104 3.55294 3.55215 2.81167 4.51902 2.42385C5.96687 1.84949 9.40245 1.98204 11.0025 1.98204C12.6025 1.98204 16.0429 1.8544 17.4859 2.42385C18.4479 2.80676 19.189 3.54803 19.5767 4.51512C20.1509 5.96329 20.0184 9.39964 20.0184 11C20.0184 12.6004 20.1509 16.0416 19.5767 17.4849Z"
                  fill="#20222C"
                />
              </svg>
            </a>
            <a
              target="_blank"
              href="https://twitter.com/OngAccionConst"
              rel="noreferrer"
            >
              <svg
                width="25"
                height="20"
                viewBox="0 0 25 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.4303 4.98436C22.4461 5.2031 22.4461 5.42188 22.4461 5.64062C22.4461 12.3125 17.2907 20 7.86805 20C4.96511 20 2.26842 19.1718 0 17.7344C0.412453 17.7812 0.808988 17.7969 1.23731 17.7969C3.63258 17.7969 5.83757 17 7.59837 15.6406C5.34582 15.5938 3.45812 14.1406 2.80773 12.1406C3.12501 12.1875 3.44225 12.2187 3.77541 12.2187C4.23542 12.2187 4.69548 12.1562 5.12375 12.0469C2.77604 11.5781 1.01519 9.54687 1.01519 7.09374V7.03126C1.69727 7.40627 2.49049 7.64064 3.33117 7.67185C1.95108 6.76558 1.04693 5.21873 1.04693 3.46871C1.04693 2.53123 1.30069 1.67186 1.74488 0.921852C4.26711 3.98435 8.05838 5.98432 12.3096 6.2031C12.2303 5.8281 12.1827 5.43752 12.1827 5.04688C12.1827 2.2656 14.467 0 17.3065 0C18.7817 0 20.1142 0.609373 21.0501 1.59375C22.2081 1.37501 23.3185 0.953114 24.3021 0.375003C23.9213 1.5469 23.1123 2.53128 22.0495 3.15624C23.0806 3.04691 24.08 2.7656 25 2.37502C24.3021 3.37498 23.4296 4.26557 22.4303 4.98436V4.98436Z"
                  fill="#20222C"
                />
              </svg>
            </a>
            <a
              target="_blank"
              href="https://www.facebook.com/ONG-Acci%C3%B3n-Constitucional-101344352392101"
              rel="noreferrer"
            >
              <svg
                width="25"
                height="30"
                viewBox="0 0 310 310"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M81.703 165.11h33.981V305a5 5 0 0 0 5 5H178.3a5 5 0 0 0 5-5V165.76h39.064a5 5 0 0 0 4.967-4.429l5.933-51.502a5 5 0 0 0-4.966-5.572h-44.996V71.973c0-9.732 5.24-14.667 15.576-14.667h29.42a5 5 0 0 0 5-5V5.032a5 5 0 0 0-5-5h-40.545a39.746 39.746 0 0 0-1.857-.037c-7.035 0-31.488 1.381-50.804 19.151-21.402 19.692-18.427 43.27-17.716 47.358v37.752H81.703a5 5 0 0 0-5 5V160.1a5 5 0 0 0 5 5.001z"
                  fill="#20222C"
                />
              </svg>
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
